const MonedaPOptions = [
  {
    label: "Selecciona",
    value: '',
  },
  {
    label: "Pesos mexicanos",
    value: "MXN",
  },
  {
    label: "Euros",
    value: "EUR",
  },
  {
    label: "Dólar americano",
    value: "USD",
  },
  {
    label: "Dólar canadiense",
    value: "CAD",
  },
  {
    label: "XXX",
    value: "XXX",
  },
];

export default MonedaPOptions;